import React, { useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({ isOpen, title, content, onConfirm, onCancel }) => {
  return (
    <Modal show={isOpen} className="cdh-form">
      <div className="result-modal">
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontWeight: 600 }}>{content}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline"
            className="btn-outline-secondary site-btn cancel-btn"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

const useConfirmModal = (title, content) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const callbackRef = useRef(null);

  const openConfirmModal = callback => {
    setIsConfirmModalOpen(true);
    callbackRef.current = callback;
  };

  const onConfirm = () => {
    if (typeof callbackRef.current === 'function') callbackRef.current();
    setIsConfirmModalOpen(false);
  };

  const onCancel = () => {
    setIsConfirmModalOpen(false);
  };

  return {
    openConfirmModal,
    ConfirmModal: () => (
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        title={title}
        content={content}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    ),
  };
};

export default useConfirmModal;
